import { GridColDef } from "@mui/x-data-grid";
import ViewCad from "../../../view";
import { ClienteViewProps, mapDispatchToClienteProps, mapStateToClienteProps } from "../cliente.controll";
import { Cliente } from "../cliente.model";
import { FormCadProps } from "../../../components/viewCadastro/formCad";
import { Endereco, initialValueEndereco } from "../../../data.types";
import { Delete, Save } from "@mui/icons-material";
import { getNewId } from "../../../services/utils";
import { useCallback, useState } from "react";
import Modal from "../../../components/modal";
import { connect } from "react-redux";
import { handleSetShowSelectMeioPagModal, MeioPagSelectList } from "../../meioPag/view/meiopg.select";
import { handleShowTabelaPrecoSelect, TabelaPrecoSelect } from "../../settings/tabelaPreco/tabpreco.view";

interface ClienteCadastroProps extends ClienteViewProps {
    handleCloseView: (row?: Cliente) => any
}

const columnsEnderecoList: GridColDef[] = [
    { field: 'rua', headerName: 'Rua', flex: 4 },
    { field: 'numero', headerName: 'N°', flex: 1 },
    { field: 'bairro', headerName: 'Bairro', flex: 3 },
    { field: 'complemento', headerName: 'Complemento', flex: 4 },
]

interface CadEnderecoProps {
    row: Cliente,
    endereco: Endereco,
    updade: (row: Cliente) => any
    handleClose: () => any
}

function CadEndereco(props: CadEnderecoProps) {
    const { handleClose, row, updade, endereco } = props
    const [showDialogExluir, setShowDialogExluir] = useState(false);
    const formValidate = (values: Endereco) => {
        const errors: any = {}
        if (!values.rua)
            errors.rua = "Informe o nome da rua"
        return errors
    }

    const handleUpdate = (value: Endereco) => {
        let cliente: Cliente = structuredClone(row);
        console.log("chamou handleUpdate endereco", [cliente, value])
        if (value._id) {//atualizar
            let idx = cliente.enderecos.findIndex(row => row._id === value._id)
            cliente.enderecos[idx] = value;
        } else {//adicionar
            value._id = getNewId();
            cliente.enderecos.push(value);
        }
        updade(cliente);
        handleClose();
    }

    const handleRemove = (value: Endereco) => {
        console.log("remover ", value);
        let enderecos: Endereco[] = [...row.enderecos];
        let idx = enderecos.findIndex(row => row._id === value._id)
        enderecos.splice(idx, 1);
        let cliente = { ...row, enderecos: enderecos }
        updade(cliente);
        handleClose();
    }

    var viewCadEndereco = new ViewCad({
        formTitle: "Cadastro do Endereço de " + row.nome,
        formFieldDescription: "rua",
        loading: false,
        msg: "",
        row: endereco,
        status: "",
        showAlert: false,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: false,
            title: "",
            onClick: () => { },
        },
        handleExcluir: handleRemove,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => { },
        setShowDialogExluir: setShowDialogExluir,
        handleCloseView: handleClose,

        contentForm: [
            { fieldName: "rua", label: "Nome da rua", type: "text", key: "rua", colunsXS: 10, colunsSM: 10, colunsMD: 10, require: true },
            { fieldName: "numero", label: "N°", type: "text", key: "numero", colunsXS: 2, colunsSM: 2, colunsMD: 2, require: false },
            { fieldName: "bairro", label: "Bairro", type: "text", key: "bairro", colunsXS: 6, colunsSM: 6, colunsMD: 6, require: false },
            { fieldName: "cep", label: "CEP", type: "text", key: "cep", colunsXS: 6, colunsSM: 6, colunsMD: 6, require: false },
            { fieldName: "cidade", label: "Cidade", type: "text", key: "cidade", colunsXS: 8, colunsSM: 8, colunsMD: 8, require: false },
            { fieldName: "uf", label: "UF", type: "text", key: "uf", colunsXS: 4, colunsSM: 4, colunsMD: 4, require: false },
            { fieldName: "contato.nome", label: "Contato Recebimento", type: "text", key: "contato", colunsXS: 6, colunsSM: 6, colunsMD: 6 },
            { fieldName: "contato.whatsapp", label: "whatsapp", type: "text", key: "whatsapp", colunsXS: 6, colunsSM: 6, colunsMD: 6 },
            { fieldName: "complemento", label: "Complemento", type: "text", key: "complemento", colunsXS: 12, colunsSM: 12, colunsMD: 12, require: false }
        ],

    })

    return viewCadEndereco
}



export function ClienteCadastro(props: ClienteCadastroProps) {
    const { clienteActions, clienteState, handleCloseView } = props
    const { error, loading, msg, row, showAlert, showDialogExluir, status } = clienteState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue } = clienteActions
    const [showCadEndereco, setShowCadEndereco] = useState<{ show: boolean, endereco: Endereco }>({ show: false, endereco: structuredClone(initialValueEndereco) });

    const handleNovo = () => {
        setClearValue();
    }

    const handleExcluir = (row: Cliente) => {
        deletar(row);
        setShowDialogExluir(false);
        handleCloseView();
    }

    const formValidate = (values: Cliente) => {
        const errors: any = {}
        if (!values.nome)
            errors.nome = "Informe o nome do cliente"
        return errors
    }

    const handleUpdate = (value: Cliente) => {
        if (!value._rev) {
            create(value);
        } else {
            update(value);
        }
    }

    const handleAlterarEndereco = (end: Endereco) => {
        setShowCadEndereco({ show: true, endereco: { ...structuredClone(initialValueEndereco), ...end } });
    }

    const handleNovoEndereco = (value: any) => {
        console.log(value)
        setShowCadEndereco({ show: true, endereco: structuredClone(initialValueEndereco) })
    }

    const handleMutator = ([value, field]: any, state: any, { changeValue }: any) => {
        changeValue(state, field, () => value);
    }

    const EnderecoView = useCallback(() => {
        const formCad = CadEndereco({
            endereco: showCadEndereco.endereco,
            handleClose: () => setShowCadEndereco({ show: false, endereco: structuredClone(initialValueEndereco) }),
            row: row,
            updade: update
        }).renderModal({
            handleClose: () => setShowCadEndereco({ show: false, endereco: structuredClone(initialValueEndereco) }),
            show: showCadEndereco.show,
            heigth: "auto",
            width: "sm"
        })

        return formCad
    }, [showCadEndereco.show])

    const ViewSelecionarMeioPagDefault = (propsMeioPagDef: any) => {
        return (
            <MeioPagSelectList handleMeioPagSelect={(mp) => {
                var value = {
                    _id: mp._id,
                    descricao: mp.descricao,
                    gerar_titulo: mp.gerar_titulo,
                }
                propsMeioPagDef.handleMutator(value, "meio_pag_default")
                handleSetShowSelectMeioPagModal(false)
            }} />
        )
    }

    const handleRemovemeioPagDefault = (mutator:(v:any,f:any)=>any) => {
        mutator({}, "meio_pag_default")

    }

    const ViewSelecionarTabelaPrecoPadrao = (propsTabela: any) => {
        return (
            <TabelaPrecoSelect handleTabelaPrecoSelect={(tab => {
                console.log(tab, propsTabela);
                var value = {
                    _id: tab._id,
                    descricao: tab.descricao
                }
                propsTabela.handleMutator(value, "tabela_preco_padrao");
                handleShowTabelaPrecoSelect(false)
            })} />
        )
    }

    const handleRemoveTabelaPrecoDefault = (mutator:(v:any,f:any)=>any) => {
        mutator({}, "tabela_preco_padrao");
    }

    var viewCad = new ViewCad({
        formTitle: "Cadastro do Cliente",
        formFieldDescription: "nome",
        loading: loading,
        msg: msg,
        row: row,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: true,
            title: "Adicionar novo cliente",
            onClick: () => handleNovo(),
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: setShowDialogExluir,
        handleCloseView: () => handleCloseView(),
        handleMutator: handleMutator,
        contentForm: [
            { fieldName: "nome", label: "Nome", type: "text", key: "nome", colunsXS: 12, colunsSM: 6, colunsMD: 4, require: true },
            { fieldName: "sobrenome", label: "Sobrenome", type: "text", key: "sobrenome", colunsXS: 12, colunsSM: 6, colunsMD: 5, require: false, },
            { fieldName: "apelido", label: "Apelido", type: "text", key: "apelido", colunsXS: 12, colunsSM: 12, colunsMD: 3, require: false, },
            { fieldName: "tipo_doc", label: "", type: "radio", key: "tipo_doc", colunsXS: 12, colunsSM: 5, colunsMD: 5, require: true, radioDefaultValue: "CPF", radioOptionsValues: [{ label: "CNPJ", value: "CNPJ" }, { label: "CPF", value: "CPF" }] },
            { fieldName: "n_doc", label: "N° Documento", type: "text", key: "n_doc", colunsXS: 12, colunsSM: 7, colunsMD: 7, require: false },
            { fieldName: "whatsapp", label: "Whatsapp", type: "text", maskInputText: "99 9 9999-9999", key: "whatsapp", colunsXS: 12, colunsSM: 3, colunsMD: 3, require: true },
            { fieldName: "fone", label: "Fone", type: "text", key: "fone", colunsXS: 12, colunsSM: 3, colunsMD: 3 },
            { fieldName: "email", label: "Email", type: "text", key: "email", colunsXS: 12, colunsSM: 3, colunsMD: 3 },
            { fieldName: "revenda", label: "Revendedor", type: "checkbox", key: "revenda", colunsXS: 12, colunsSM: 3, colunsMD: 3, },
            { fieldName: "meio_pag_default.descricao", label: "Meio de Pagamento Padrão", type: "select-dialog", key: "meio_pag_default", colunsXS: 12, colunsSM: 6, colunsMD: 6, ViewSelecionarDialog: ViewSelecionarMeioPagDefault, handleOnClickShow: () => handleSetShowSelectMeioPagModal(true), handleOnClickRemove: (v,f) => f&&handleRemovemeioPagDefault(f),showButtonLimparSelectDialog:true },
            { fieldName: "tabela_preco_padrao.descricao", label: "Tabela Preço Padrão", type: "select-dialog", key: "tabela_preco_padrao", colunsXS: 12, colunsSM: 6, colunsMD: 6, ViewSelecionarDialog: ViewSelecionarTabelaPrecoPadrao, handleOnClickShow: () => handleShowTabelaPrecoSelect(true), handleOnClickRemove: (v,f) => f&&handleRemoveTabelaPrecoDefault(f), showButtonLimparSelectDialog:true },

            { fieldName: "enderecos", label: "Endereços", type: "list", key: "endereco", colunsXS: 12, colunsSM: 12, colunsMD: 12, columns: columnsEnderecoList, fieldList: { fieldPrimary: "rua", fieldSecondary: "complemento", fieldSecondaryEnd: "numero" }, tip: "Salve o cliente antes de informar o endereço.", handleOnClickShow: (value) => { value._id && handleNovoEndereco(value) }, handleOnClickUpdade: (v) => handleAlterarEndereco(v) },
        ],
        ContentBox: EnderecoView
    })

    return viewCad
}


function ClienteCadModal(props: ClienteCadastroProps) {
    const { handleCloseView } = props
    const { showCadModal, row } = props.clienteState


    const handleClose = () => {
        handleCloseView(row);
    }

    return ClienteCadastro({
        ...props,
        handleCloseView: handleClose
    }).renderModal({
        handleClose: handleClose,
        show: showCadModal,
        heigth: "auto",
        width: "sm",
    })

}

export const ViewClienteCadModal = connect(mapStateToClienteProps, mapDispatchToClienteProps)(ClienteCadModal);



